import { RULES_PRINT_PATH } from '../../lib/nav';
import type { PageRoute } from '../../page-route';
import { RulesPrintPage } from './page';

export const route: PageRoute = { path: RULES_PRINT_PATH, access: 'authed', Component: RulesPrintPage };
